var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import DateHelper from "../../helper/DateHelper.js";
import StringDataField from "./StringDataField.js";
class DurationUnitDataField extends StringDataField {
  isEqual(first, second) {
    return DateHelper.compareUnits(first, second) === 0;
  }
}
__publicField(DurationUnitDataField, "$name", "DurationUnitDataField");
__publicField(DurationUnitDataField, "type", "durationunit");
DurationUnitDataField.initClass();
DurationUnitDataField._$name = "DurationUnitDataField";
export {
  DurationUnitDataField as default
};
